import { createSelector } from 'reselect';

import { AppState } from '../../store/store';
import { CustomerState } from './customer-reducer';

const customerState = (state: AppState): CustomerState => state.customer;

export const customersSelector = createSelector(customerState, (state: CustomerState) => state.customers.items);
